import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Link } from '@mui/material';
import { APP_NAME } from '../../core/environment/environment';
import pesapalLogo from '../../assets/pesapallogo.png';
// @mui

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx, ...other }, ref) => {
  const logo = (
    <Box sx={{ 
      width: 160, 
      height: 60, 
      cursor: 'pointer', 
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      ...sx 
    }}>
      <img 
        alt={APP_NAME} 
        src={pesapalLogo} 
        style={{ 
          maxWidth: '100%', 
          maxHeight: '100%', 
          objectFit: 'contain',
          display: 'block'
        }} 
      />
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return (
    <Link to="/" component={RouterLink} sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
};

export default Logo;
